import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../modules';
import { getContentsAsync } from '../../modules/editor';

type Props = {
};

function ForceSetContents({  }: Props) {
  const dispatch = useDispatch();
  const [content, setContent] = useState('');

  const email = useSelector((state: RootState) => state.editor.email);

  const handleChange = (e:any) => {		
    const { value } = e.target;
    setContent(value);
  }

  const handleClick = () => {	
    const c:any = JSON.parse(content);
    dispatch(getContentsAsync.success(c.data));
  }

  return (
    <div style={{padding: '20px'}}>
      <pre>{email.permanentLink}</pre>
      <textarea onChange={handleChange} style={{width: '100%', height: '200px'}} />
      <br />
      <button className="btn medium" onClick={handleClick}>입력</button>
    </div>
  );
}

ForceSetContents.defaultProps = {
};

export default ForceSetContents;